/* AEF — per-variant MOQ on PDP (2026-06).
   🔴 24/10/2026 (min-max THEO BIẾN THỂ, plan C2) — FILE NÀY THÔI TÍNH LUẬT.
   Trước đây nó tính lại min bằng `tier()` (bậc giá) + một "luật đè" chụp từ
   `data-min-qty-base`, 80 ms sau khi tải — tức một BẢN CHÉP thứ hai của
   snippets/aef-min-qty.liquid. Nay mỗi biến thể có ô "Mua tối thiểu" riêng, bản chép
   ấy không biết ô đó ⇒ nó sẽ đè số đúng của máy chủ bằng số sai. Nên: máy chủ giải
   min cho TỪNG biến thể vào khoá "n" của bảng `aef-variant-meta-<id>`
   (sections/main-product.liquid), file này chỉ ĐỌC khoá đó khi khách đổi quy cách.
   SP một quy cách không có bảng ⇒ giữ nguyên số máy chủ in, không ghi gì — trừ khi khách
   chọn gói định kỳ (30/10/2026, xem giaGoiDangChon): min vẫn là số máy chủ in, chỉ đơn giá đổi.
   Enforcement reuses the theme's own path (data-min-qty + mini-cart-popup clamp);
   this only feeds the right number per variant + manages the "Min order" hint. */
(function () {
  var meta = null, coBang = false;   // coBang: có bảng aef-variant-meta (SP nhiều quy cách)

  // ── PHẠM VI: CHỈ khối mua của PDP, tuyệt đối không chạm ra ngoài ────────────
  //
  // 2026-08-16 — VÁ LỖI XOÁ SẠCH DÒNG GIỎ HÀNG.
  //   Trước đây file này hỏi và ghi bằng `document.querySelectorAll('[data-min-qty]')`
  //   và `document.querySelector('.quantity__input')` — tức TOÀN TÀI LIỆU. Mà PDP
  //   không phải nơi duy nhất mang hai dấu hiệu đó:
  //     · sections/aef-cart-drawer.liquid:109 và :140 — hàng trong GIỎ TRƯỢT, mà giỏ
  //       trượt render trên MỌI trang (layout/theme.liquid:449)
  //     · snippets/product-card.liquid:126 và :309 — thẻ SP gợi ý ngay trên chính PDP
  //     · snippets/mini-cart-popup.liquid:99 — ô số lượng trong popup giỏ ở HEADER,
  //       và header đứng TRƯỚC thân trang nên `document.querySelector` trúng nó TRƯỚC
  //   Hậu quả nặng nhất: min bịa theo bậc giá của SP đang xem bị ghi đè lên min THẬT
  //   của hàng trong giỏ. card-stepper.js:313-315 có luật `cur <= rules.min → next = 0`
  //   ⇒ khách bấm "−" tưởng bớt 1, nhưng /cart/change.js nhận quantity 0 = XOÁ CẢ DÒNG.
  //   Tạp hoá Á châu phần lớn SKU dưới $3,50 nên hầu như xem SP nào cũng gài được bẫy.
  //
  //   Từ đây mọi thao tác đi qua ĐÚNG ba chỗ của PDP (sections/main-product.liquid
  //   :1180 ô số lượng · :1461 khối mua · :1547 stepper). Ba dấu hiệu này chỉ
  //   main-product.liquid mới sinh ra — đã grep toàn theme để chắc.
  /* 🔴 24/8/2026 — ĐƯỜNG THỨ HAI, và vì sao bắt buộc phải có.
     Khối JSON `aef-variant-meta-<id>` chỉ được vẽ trong nhánh
     `{% unless product.has_only_default_variant %}` của main-product.liquid ⇒
     hàng MỘT quy cách hoàn toàn không có nó. Khi đó sectionId = null →
     `pdpQtyInput()` = null → `captureOverride()` đọc metafield TỪ CHÍNH ô số
     lượng nên trả 0 → luật đè mất → `apply()` rơi về bậc-giá.
     Đo trên trang thật: Knorr Liquid Seasoning ($6.49, custom.min_qty = 2) —
     máy chủ vẽ min=2 ở cả bốn chỗ, JS chạy xong còn min=1 ở `.aef-pdp-buy` và
     `.aef-pdp-stepper`, dòng "Min order: 2" bị `ensureHint` ẩn đi. Bấm "−" một
     cái là giỏ còn 1, dưới mức tối thiểu, không cảnh báo gì.
     Quét kho: **78 sản phẩm** đang tụt như vậy (74 cái 2→1 · 3 cái 3→2 · 1 cái 4→3).

     Vì sao KHÔNG chữa bằng cách vẽ khối meta cho cả hàng một-quy-cách: `loadMeta()`
     bật cờ `coBang` (trước 25/10 tên là `cheapestId` — id biến thể rẻ nhất, nay chỉ còn
     làm cờ "có bảng") từ khối đó, và `selected()` rẽ sang nhánh nhiều-quy-cách ngay khi
     cờ bật. Với một quy cách, nhánh đó dò nhãn không ra id ⇒ luật đè vẫn mất, chỉ là mất
     theo đường khác. Nên phải giữ cờ tắt và chỉ thêm một cái neo mang sectionId.

     ⚠️ Neo phải nằm TRONG phạm vi PDP. Đừng đổi thành `.quantity__input` —
     class đó có mặt ở 10 chỗ khác và popup giỏ ở header đứng TRƯỚC thân trang. */
  function pdpSectionId() {
    var m = document.querySelector('[id^="aef-variant-meta-"]');
    if (m) return m.id.slice('aef-variant-meta-'.length);
    var neo = document.querySelector('[data-aef-pdp-buy][data-aef-section]');
    var sid = neo && neo.getAttribute('data-aef-section');
    return sid || null;
  }

  // Ô số lượng của PDP — lấy theo id `Quantity-<sectionId>` chứ KHÔNG theo class
  // `.quantity__input`: class đó có mặt ở 10 chỗ khác, trong đó popup giỏ ở header
  // đứng trước thân trang. Không tìm thấy thì trả null và không đụng gì cả.
  function pdpQtyInput() {
    var sid = pdpSectionId();
    return sid ? document.getElementById('Quantity-' + sid) : null;
  }

  /* 🔴 15/9/2026, vòng 49 — BIẾN THỂ ĐANG CHỌN: HỎI BẢN GỐC, ĐỪNG HỎI BẢN CHÉP.
     `input[name="id"]` của form mua là chỗ danh tính biến thể được XÁC LẬP:
     `VariantSelects.updateVariantInput()` (assets/global.js) ghi nó ĐỒNG BỘ ngay
     trong pha bubble của cùng cú `change`, trước mọi setTimeout. Mọi khoá khác
     trên PDP (`[data-aef-pdp-buy] data-variant-id`, ô tăng-giảm) đều do
     `syncVariant()` CHÉP LẠI từ đúng ô này, và chép ở một nhịp sau.

     Id của form KHÔNG chép hằng `'product-form-' + sid`: ô số lượng mang sẵn
     `form="{{ product_form_id }}"` (sections/main-product.liquid) nên đọc thẳng
     thuộc tính đó — một nguồn, Liquid đổi tên form thì chỗ này đi theo. */
  function pdpFormVariantId() {
    var q = pdpQtyInput();
    if (!q) return null;
    var fid = q.getAttribute('form');
    var f = (fid && document.getElementById(fid)) || q.form || null;
    var inp = f && f.querySelector ? f.querySelector('input[name="id"]') : null;
    var v = inp && inp.value != null ? String(inp.value).trim() : '';
    return v || null;
  }

  // Mọi phần tử PDP mang data-min-qty. KHÔNG bao giờ trả về hàng giỏ hay thẻ SP.
  function pdpMinHosts() {
    var list = [];
    var q = pdpQtyInput();
    if (q) list.push(q);
    var extra = document.querySelectorAll('[data-aef-pdp-buy], .aef-pdp-stepper');
    for (var i = 0; i < extra.length; i++) list.push(extra[i]);
    return list;
  }

  function loadMeta() {
    if (meta !== null) return meta;
    var el = document.querySelector('[id^="aef-variant-meta-"]');
    try { meta = el ? JSON.parse(el.textContent) : {}; } catch (e) { meta = {}; }
    /* Cùng điều kiện bật như trước 25/10 (có ít nhất một biến thể mang giá số) — chỉ đổi tên. */
    for (var k in meta) {
      if (meta[k] && typeof meta[k].p === 'number') { coBang = true; break; }
    }
    return meta;
  }

  /* (24/10/2026) `captureOverride()` + `data-min-qty-base` đã gỡ: luật đè cấp SP chỉ còn
     ở đường lùi của snippets/aef-min-qty.liquid, và con số đã giải cho TỪNG biến thể
     nằm sẵn ở khoá "n" — xem đầu file. Lịch sử vòng 42: git log -- assets/aef-moq-relax.js */

  function selectedLabel() {
    var r = document.querySelector(
      'variant-radios input[type="radio"]:checked,' +
      '.product-form__input input[type="radio"]:checked,' +
      'fieldset.product-form__input input[type="radio"]:checked'
    );
    if (r && r.value) return r.value.trim();
    var s = document.querySelector('variant-selects select, .product-form__input select');
    if (s && s.value) return s.value.trim();
    return null;
  }

  // returns {id, price:cents}
  function selected() {
    var m = loadMeta();
    if (coBang) { // multi-variant
      var label = selectedLabel(), id = null;
      /* 🔴 5/9/2026, vòng 42 — HỎI THẲNG ID BIẾN THỂ, ĐỪNG BÓC CHỮ TRÊN NHÃN.
         Bản cũ chỉ có hai đường: dò nhãn rồi mới tới `?variant=`. Dò nhãn so
         `m[k].t` (= TIÊU ĐỀ BIẾN THỂ, main-product.liquid `{{ v.title | json }}`,
         ví dụ "Small / Spicy") với `value` của radio (= GIÁ TRỊ MỘT TUỲ CHỌN,
         "Small"). Hai đơn vị khác nhau ⇒ SP từ 2 tuỳ chọn trở lên không bao giờ
         khớp: đo được min tụt 3 → 1 ở cả ba đích PDP và cả hai dòng
         "Min order: 3 · $8.97" bị ẩn, ở lượt vẽ đầu của URL không mang `?variant=`.
         Kho hiện chưa có SP nào ≥2 tuỳ chọn (0/133 biến thể trong hai CSV đồng bộ,
         0/131 trong audit-variant-sales) nên đây là BẪY NGỦ, không phải lỗi đang
         cắn khách — nhưng vá thì rẻ và đúng hướng một-nguồn.
         Neo `[data-aef-pdp-buy][data-variant-id]` do main-product.liquid vẽ theo
         `default_variant` và do `syncVariant()` (cùng file) cập nhật mỗi lần khách
         đổi quy cách — tức đúng cái id mà KHỐI MUA đang dùng, thay vì để file này
         tự chế nguồn thứ hai bằng cách đoán chữ. Hai đường cũ giữ nguyên làm dự
         phòng cho lượt chạy sớm hơn `syncVariant()`. */
      /* 🔴 15/9/2026, vòng 49 — NEO CỦA KHỐI MUA ĐI SAU ĐÚNG MỘT NHỊP.
         `data-variant-id` chỉ có MỘT người ghi lúc chạy: `syncVariant()` của
         sections/main-product.liquid, và nó được hẹn bằng `setTimeout(…, 0)` từ
         một listener `change` ở pha BUBBLE của document. File này hẹn `apply(true)`
         từ listener ở pha CAPTURE (dòng cuối file) — capture chạy TRƯỚC bubble nên
         hẹn giờ của file này vào hàng đợi TRƯỚC. Ở lượt 0ms neo vẫn mang id quy
         cách CŨ, mà `m[idNeo]` vẫn có thật ⇒ `id` được gán và ba đường phía sau
         không bao giờ tới lượt. Lượt 160ms mới chữa lại.
         Khách chịu gì: hao-hao ($1,99 · min 3) bấm sang "pack of 12" ($23,99 ·
         min 1) — suốt 0→160ms ô số lượng vẫn chở 3 và `data-unit-price` vẫn 199.
         Bấm "Add to cart" trong cửa sổ đó thì `queueAdd` của mini-cart-popup.js
         đọc đúng hai con số ấy ⇒ giỏ nhận 3 × $23,99 = $71,97. Quét kho: 195 cặp
         biến thể-còn-hàng lệch bậc mua tối thiểu.
         Nay hỏi `pdpFormVariantId()` TRƯỚC — bản gốc không bao giờ chậm hơn bản
         chép. Neo vẫn giữ làm dự phòng: nếu khách đổi quy cách bằng một đường
         KHÔNG đi qua VariantSelects thì neo lại là thứ đúng.
         ⛔ Đừng chữa bằng cách bỏ lượt 0ms — như vậy khách nhìn số cũ LÂU HƠN.
         ⛔ Cũng đừng đảo lên cho `selectedLabel()` chạy trước: dò nhãn so GIÁ TRỊ
            MỘT TUỲ CHỌN với TIÊU ĐỀ BIẾN THỂ, tức trả lại đúng bẫy ngủ vòng 42. */
      var idForm = pdpFormVariantId();
      if (idForm && m[idForm]) id = String(idForm);
      var neoBt = document.querySelector('[data-aef-pdp-buy][data-variant-id]');
      var idNeo = !id && neoBt && neoBt.getAttribute('data-variant-id');
      if (idNeo && m[idNeo]) id = String(idNeo);
      if (!id && label) for (var k in m) { if (m[k] && m[k].t && String(m[k].t).trim() === label) { id = String(k); break; } }
      if (!id) { var mt = location.search.match(/[?&]variant=(\d+)/); if (mt) id = mt[1]; }
      var p = id && m[id] && typeof m[id].p === 'number' ? m[id].p : NaN;
      return { id: id, price: p };
    }
    // một quy cách: apply() dừng trước khi tới đây (số máy chủ in là số đúng).
    return { id: null, price: NaN };
  }

  /* 🔴 17/8 vòng 16 — GHI CHỮ MÀ KHÔNG GIẾT KHOÁ DỊCH.
     Bản cũ: `h.textContent = 'Min order: ' + min`.
     `h` là `.pdp-min-hint`, mà máy chủ dựng nó theo đúng luật của dự án — số
     nằm NGOÀI span dịch:
         <span class="pdp-min-hint"><span data-i18n="card.min_hint">Min order:</span> 3</span>
     Ghi `textContent` lên thẻ CHA là XOÁ SẠCH thẻ con mang `data-i18n`. Từ đó
     `applyTranslations()` không còn gì để bám — dòng này kẹt tiếng Anh VĨNH
     VIỄN, và tái phát sau mỗi lần đổi biến thể. 955 SP có `custom.min_qty`.
     Nay: giữ nguyên span khoá, chỉ thay phần SỐ. Chữ lấy qua `window.aefT` để
     nhánh tạo-mới (SP không có metafield) cũng ra đúng tiếng. */
  function chuMinOrder() {
    var t = (typeof window.aefT === 'function') && window.aefT('card.min_hint');
    return t || 'Min order:';
  }

  /* 18/8/2026 — dòng này phải nói cả THÀNH TIỀN, không chỉ số lượng.
     Đơn giá lấy từ `selected().price` (đã là XU, do chính file này tính ra để
     xét bậc giá) — KHÔNG đọc ngược chuỗi tiền đang hiện trên màn hình: đọc
     ngược là nhân lại sai số làm tròn của chính mình, và hỏng ngay khi tiệm
     đổi money_format. */
  /* 23/10/2026 (GG1) — tiền đi qua MỘT hàm window.aefTien (layout/theme.liquid, <head>),
     cùng định dạng filter money của Liquid; nhánh Shopify.formatMoney cũ là mã chết (LIVE
     không có hàm đó) — đã gỡ.
     30/10/2026 (/code-review 287d9d08 #11): đã gỡ dự phòng tự nối dấu đô — tệp này chỉ nạp dưới
     layout/theme.liquid (qua snippets/faq-schema), nơi aefTien có sẵn từ <head> trước mọi section,
     nên nhánh đó chưa từng chạy trên trang thật. Người gác: scripts/test-tien-mot-dinh-dang.js CA 6 */
  function money(cents) {
    if (!isFinite(cents)) return '';
    return window.aefTien(cents);
  }
  /* `gia` = đơn giá của biến thể ĐANG CHỌN, bằng xu. Phần đuôi " · $X.XX" là
     node ANH EM của span mang data-i18n (BUG-J), nên lượt dịch sau vẫn bám được
     vào nhãn mà không nuốt mất số tiền. */
  function duoiHint(min, gia) {
    var t = money(gia * min);
    return ' ' + min + (t ? ' · ' + t : '');
  }

  function ghiHint(h, min, gia) {
    var nhan = h.querySelector('[data-i18n="card.min_hint"]');
    if (!nhan) {
      // Thẻ do chính JS này tạo ra ở lượt trước, hoặc markup lạ → dựng lại đủ
      // cấu trúc thay vì ghi đè phẳng, để lượt dịch sau còn chỗ bám.
      h.textContent = '';
      nhan = document.createElement('span');
      nhan.setAttribute('data-i18n', 'card.min_hint');
      nhan.textContent = chuMinOrder();
      h.appendChild(nhan);
      h.appendChild(document.createTextNode(duoiHint(min, gia)));
      return;
    }
    // Chỉ đụng phần SỐ: xoá mọi node anh em phía sau nhãn rồi ghi lại con số.
    while (nhan.nextSibling) h.removeChild(nhan.nextSibling);
    h.appendChild(document.createTextNode(duoiHint(min, gia)));
  }

  /* 01/11/2026 — `het`: gói đang chọn hết hàng thì không nói "Min order" cạnh nút Sold out.
     data-min-qty vẫn ghi như thường, chỉ dòng chữ tắt. Máy chủ in sẵn display:none cho gói mặc
     định hết hàng; lượt đổi gói ở đây bật/tắt lại. Thanh dính bỏ qua dòng đang ẩn (nguonMin). */
  function ensureHint(min, gia, het) {
    var hints = document.querySelectorAll('.pdp-min-hint');
    if (min <= 1 || het) { hints.forEach(function (h) { h.style.display = 'none'; }); return; }
    if (hints.length) {
      hints.forEach(function (h) { h.style.display = ''; ghiHint(h, min, gia); });
      return;
    }
    // none rendered server-side (product had no metafield) → create one
    var anchor = pdpQtyInput();
    anchor = anchor ? (anchor.closest('.product-form__input, quantity-input, .product-form__buttons') || anchor.parentNode) : null;
    if (!anchor) return;
    var s = document.createElement('span');
    /* 25/8/2026 — BỎ MÀU GHI CỨNG INLINE.
       Chú thích cũ ở đây nói đúng vấn đề: hai dòng cùng nội dung, cùng vị trí
       mà khác màu thì khách tưởng là hai loại thông tin. Nhưng cách chữa cũ —
       chép màu vào style inline — lại tạo ra đúng cái nó muốn tránh, ở chiều
       ngược lại: sau khi biến thể cạnh nút mua đổi sang đỏ cảnh báo, nhánh JS
       vẫn xanh, và vì là INLINE nên không lớp nào đè lại được.
       Nay luật gốc nằm trong khối style LUÔN ĐƯỢC NHẢ của main-product.liquid,
       nên ở đây chỉ cần gắn đúng lớp và để CSS quyết màu — một nguồn duy nhất.
       Neo vào khu nút mua thì mang thêm lớp biến thể, y như bản máy chủ dựng. */
    var canhNutMua = !!(anchor.closest && anchor.closest('.product-form__buttons, [data-aef-pdp-buy]'));
    s.className = 'pdp-min-hint' + (canhNutMua ? ' pdp-min-hint--buy' : '');
    ghiHint(s, min, gia);   // qua cùng một cửa ⇒ có span data-i18n, dịch được
    anchor.parentNode.insertBefore(s, anchor.nextSibling);
  }

  function setMin(min, resetValue, gia, het) {
    pdpMinHosts().forEach(function (el) { el.setAttribute('data-min-qty', String(min)); });
    var inp = pdpQtyInput();
    if (inp) {
      inp.setAttribute('min', String(min));
      /* 18/8/2026 — đơn giá phải đi THEO biến thể. Máy chủ in data-unit-price
         theo default_variant (main-product.liquid); khách bấm sang biến thể khác
         là con số đó thành giá cũ, mà product-form.js + mini-cart-popup.js lại
         đọc đúng thuộc tính này để dựng "Min order: 3 · $5.97". Ghi đè ngay đây
         — cùng chỗ đã ghi data-min-qty, để hai số không bao giờ lệch pha nhau. */
      if (isFinite(gia) && gia > 0) inp.setAttribute('data-unit-price', String(gia));
      var v = parseInt(inp.value, 10);
      if (resetValue) inp.value = String(min);
      else if (isFinite(v) && v < min) inp.value = String(min);
    }
    ensureHint(min, gia, het);
  }

  /* 🔴 30/10/2026 (làn gio-2) — ĐƠN GIÁ LÀ CỦA LỰA CHỌN MUA, KHÔNG CHỈ CỦA BIẾN THỂ.
     Khách chọn gói định kỳ ở khối app Shopify Subscriptions: giá mua nhảy về $1.89 mà dòng này
     vẫn "Min order: 3 · $5.97", giỏ tính $5.67 (999 Sardines, một quy cách, Min 3). Bảng meta và
     số máy chủ in chỉ biết giá mua một lần; với SP một quy cách file này còn không chạy tới.
     Ô radio đang chọn của app là chỗ DUY NHẤT biết giá gói: chính app lấy data-variant-price của
     ô đó ghi lên khối giá (updateThemePrice) ⇒ đọc cùng chỗ thì dòng Min không thể cãi giá mua.
     CHỈ ĐỌC: không ghi gì vào khối app, không đụng ô ẩn selling_plan.
     ⚠️ Đây là chuỗi đã định dạng ("$1.89 USD") — ngược với luật "không đọc ngược chuỗi tiền" ở
     trên, nhưng app không phơi số xu ở đâu, còn dựng bảng giá gói bằng Liquid thì đụng
     main-product.liquid đang sát trần 256 KiB. Chỉ nhận khuôn <số>.<hai số lẻ>; khuôn khác (tiệm
     đổi money_format) ⇒ NaN ⇒ dòng Min bỏ phần tiền: thiếu tiền còn hơn tiền sai.
     Trả về: null = không chọn gói (mua một lần · SP không có khối app · chưa biết biến thể);
     số = xu; NaN = đang chọn gói mà không đọc được giá.
     Người gác: scripts/test-min-theo-lua-chon-mua.js */
  function xuTuChuoiGia(s) {
    var m = String(s || '').match(/(\d{1,3}(?:,\d{3})+|\d+)\.(\d{2})(?!\d)/);
    return m ? parseInt(m[1].replace(/,/g, '') + m[2], 10) : NaN;
  }
  function giaGoiDangChon(vid) {
    if (!/^\d+$/.test(String(vid || ''))) return null;
    var r = document.querySelector('.shopify_subscriptions_app_block[data-variant-id="' + vid + '"] input[type="radio"][data-radio-type]:checked');
    if (!r || r.getAttribute('data-radio-type') === 'one_time_purchase') return null;
    return xuTuChuoiGia(r.getAttribute('data-variant-price'));
  }

  /* 🔴 25/10/2026 (/code-review, làn min-max-2) — KHÔNG TRA ĐƯỢC BIẾN THỂ THÌ ĐỪNG GIỮ SỐ CỦA
     QUY CÁCH TRƯỚC. Bản trước `return` im lặng ⇒ ba đích PDP giữ min + đơn giá của quy cách khách
     vừa rời — số phụ thuộc LỊCH SỬ BẤM (vào lẻ $0,99 min 4 → gói → thùng vắng bảng: giữ 4, ép mua
     4 thùng). Đường "đọc biến thể từ input[name=id] của form" đã có sẵn từ vòng 49 (selected() hỏi
     pdpFormVariantId() TRƯỚC mọi đường khác) và bảng meta chở MỌI biến thể ⇒ nhánh này chỉ còn khi
     id vắng khỏi bảng / không đọc được — gần như không xảy ra. Chọn cách:
       · không đọc được id, hoặc id CHÍNH LÀ biến thể trang được dựng ⇒ SỐ MÁY CHỦ IN (min + đơn
         giá của ô số lượng — khối mua nếu không có ô), CHỤP trước lượt ghi đầu tiên của file này:
         file này là người ghi DUY NHẤT hai thuộc tính đó trên PDP, lúc chụp chúng còn nguyên;
       · đọc được id của biến thể KHÁC mà bảng không có số ⇒ min 1, ẩn dòng nhắc: không ép số của
         quy cách nào lên một quy cách mình không biết (ép là đẻ tiền sai: 4 thùng × $49,99).
     ⚠️ Giỏ KHÔNG phải người chặn cuối ở nhánh này: PDP bật nút "Buy it now" (templates/product.json
     show_dynamic_checkout) đi thẳng sang thanh toán, không qua /cart hay ngăn giỏ ⇒ ở nhánh "min 1"
     khách có thể mua dưới sàn. Chấp nhận vì nhánh gần như không chạm tới (người soi soi-min-max-2).
     Người gác: scripts/test-moq-doc-dung-nguon-doi-bien-the.js (hai CA "vắng bảng"). */
  var soMayChu = null;
  function chupSoMayChu() {
    if (soMayChu) return soMayChu;
    var q = pdpQtyInput();
    var host = document.querySelector('[data-aef-pdp-buy]');
    var nguon = q || host;
    soMayChu = {
      id: host ? String(host.getAttribute('data-variant-id') || '') : '',
      n: nguon ? parseInt(nguon.getAttribute('data-min-qty'), 10) : NaN,
      p: q ? parseInt(q.getAttribute('data-unit-price'), 10) : NaN
    };
    return soMayChu;
  }

  var daGhiGiaGoi = false;   // một quy cách: đã ghi giá gói ⇒ bỏ gói phải trả lại số máy chủ in
  function apply(resetValue) {
    var m = loadMeta();
    var goc = chupSoMayChu();   // TRƯỚC mọi lượt ghi, kể cả lượt ghi giá gói của SP một quy cách
    var giaGoi;
    if (!coBang) {
      /* Một quy cách: min luôn là số máy chủ in, không đặt lại số lượng. Chưa ai chọn gói thì
         không ghi gì (giữ nguyên hành vi cũ, từng byte máy chủ in). */
      giaGoi = giaGoiDangChon(pdpFormVariantId() || goc.id);
      if (giaGoi === null && !daGhiGiaGoi) return;
      daGhiGiaGoi = giaGoi !== null;
      var nutMua = document.querySelector('[data-aef-pdp-buy] .product-form__submit');
      if (goc.n >= 1) setMin(goc.n, false, giaGoi === null ? goc.p : giaGoi, !!nutMua && nutMua.disabled);
      return;
    }
    var sel = selected();
    var bt = sel.id ? m[sel.id] : null;
    var min = bt && typeof bt.n === 'number' ? bt.n : NaN;
    var gia = sel.price;
    if (!(min >= 1)) {                       // không tra được trong bảng (xem khối chú thích trên)
      if (!sel.id || String(sel.id) === goc.id) { min = goc.n; gia = goc.p; }
      else { min = 1; gia = NaN; }
    }
    if (!(min >= 1)) return;
    giaGoi = giaGoiDangChon(sel.id || goc.id);
    if (giaGoi !== null) gia = giaGoi;
    setMin(min, !!resetValue, gia, !!bt && bt.a === false);
  }

  function boot() { setTimeout(function () { apply(false); }, 80); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();

  function onChange() { setTimeout(function () { apply(true); }, 0); setTimeout(function () { apply(true); }, 160); }
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (t && t.closest && t.closest('variant-radios, variant-selects, .product-form__input')) onChange();
  }, true);
  document.addEventListener('variant:change', onChange);
  document.addEventListener('on:variant:change', onChange);
  /* 30/10/2026 (làn gio-2) — đổi LỰA CHỌN MUA ở khối app: đơn giá đổi, số lượng khách đang để thì
     KHÔNG đặt lại (khác đổi quy cách) ⇒ apply(false). Hẹn setTimeout vì pha capture chạy TRƯỚC
     listener của app, mà kiểu hộp xổ chỉ ghi data-variant-price lên radio nhóm trong listener đó. */
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (t && t.closest && t.closest('.shopify_subscriptions_app_container')) setTimeout(function () { apply(false); }, 0);
  }, true);
  /* Chạm hộp xổ gói: app (handleDropdownFocus) tự chọn gói mà KHÔNG phát change. */
  document.addEventListener('focusin', function (e) {
    var t = e.target;
    if (t && t.closest && t.closest('.shopify_subscriptions_app_container .group_dropdown')) setTimeout(function () { apply(false); }, 0);
  }, true);
})();
